<template>
  <menu class="navigation-top">
    <section class="navigation-top__container">
      <div class="navigation-top__back">
        <router-link :to="link" class="navigation-top__icon">
          <svg-icon id="arrow-bolder" />
        </router-link>

        <div class="navigation-top__heading">
          <router-link :to="link">Accueil</router-link>
          <span> / {{ name }}</span>
        </div>
      </div>
    </section>
  </menu>
</template>

<script>
export default {
  name: 'NavigationTop',
  props: {
    name: { type: String },
    link: { type: String }
  }
}
</script>
